export default "__VITE_ASSET__AsRRd96Z__"